import React, { useEffect } from "react";
import { toast } from "react-toastify";
import { useRef, useState } from "react";
import SimpleReactValidator from "simple-react-validator";
import { Button, Spinner } from "react-bootstrap-v5";
import { CategoryService } from "../../Services";

export const EditCategory = ({ setEditModal, getDetail, editId }) => {
  const [, setForceUpdate] = useState("");
  const [loader, setLoader] = useState(false);
  const [state, setState] = useState({
    category_name: "",
  });

  const getSingleCategory = async () => {
    const obj = {
      id: editId,
    };
    await CategoryService.getSingalCategory(obj).then((res) => {
      setState(res?.data[0]);
    });
  };

  const Validator = useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: setForceUpdate },
    })
  );

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState({ ...state, [name]: value });
  };


  const handleSubmit = () => {
    let validate = Validator.current.allValid();
    let obj = {
      id : state._id,
      category_name : state.category_name
    }


    if (validate) {
      CategoryService.editCategory(obj).then((res) => {
        setLoader(true);
        if (res?.status) {
          toast.success(res.message);
          setState(res?.data);
          setLoader(false);
          getDetail();
          setEditModal(false);
        } else {
          setLoader(false);
          toast.error(res?.message);
        }
      });
      //   .catch((err)=>{
      // 	toast.err(err.message)
      //   })
    } else {
      Validator.current.showMessages();
    }
  };

  useEffect(() => {
    getSingleCategory();
  }, []);

  return (
    <div>
      <div className="mb-3 col-12">
        {/* <label className="form-label mb-1">Category Name</label> */}
        <input
          type="text"
          className="form-control"
          name="category_name"
          value={state?.category_name}
          placeholder="Name"
          onChange={(e) => handleChange(e)}
        />
        {Validator.current.message(
          "Category name",
          state?.category_name,
          "required",
          { className: "text-danger" }
        )}
      </div>
      <div>
        <Button
          type="submit"
          className="mt-2 mx-auto d-block w-25"
          onClick={handleSubmit}
        >
          {(loader && <Spinner animation="grow" size="sm" />) || "Save"}
        </Button>
      </div>
    </div>
  );
};
